import { useFormik } from 'formik';
import React, { useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../../assets/images/logo/logo-white.png";
import '../../index.css';
import { ForgetSchema } from '../Components/Schemes/ForgetScheme';
import Routes from '../Components/data/remote/Routes';
import { ToastContainer, toast } from 'react-toastify';
import { Puff } from 'react-loader-spinner';



const notify = (message, type) => {
  // alert('error', +message)
  type == "success" ? toast.success(message, {

    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    closeButton: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",

  })
    :
    toast.error(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      closeButton: false,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",

      style: {
        backgroundColor: '#D92533'
      }
    });
}
const ForgetPassword = () => {

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const initialValues = {
    email: "",
    password: "",
    confirm_password: ""

  };

  const history = useNavigate();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues,
      validationSchema: ForgetSchema,
      validateOnChange: true,
      validateOnBlur: false,
      //// By disabling validation onChange and onBlur formik will validate on submit.
      onSubmit: (values, action) => {
        setLoading(true);

        //Calling Login Api
        var formdata = new FormData();
        formdata.append("email", values.email);
        formdata.append("password", values.password);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow'
        };

        fetch(Routes.FORGETPASSWORD, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status == true) {
              history("/otp");
              notify(result.message, "success");
              setLoading(false);

            } else {
              notify(result.message, "error");
              setLoading(false);

            }

          })
          .catch(error => {
            console.log('error', error)
            setLoading(false);

          });
      },
    });
  return (
    <div className="container-fluid loginpage">
      <ToastContainer
      />
      {loading &&
        <div className="loaderScreen">
          <Puff
            height={80}
            width={80}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      }
      <div className="col-sd-3 col-md-6 col-lg-4  container card card-forget d-flex justify-content-center">
        <div style={{ textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: 'center', textAlign: 'center' }}>
          <Link to={'/'} style={{ width: '50%' }}>
            <img src={logo1} className=" " alt="..." />
          </Link>
        </div>
        <Link to={'/'}><h5 className="card-title">AL Asab</h5></Link>
        <form onSubmit={handleSubmit} className="card-body card-body-forget" noValidate>

          <div className="login-text-area mt-3 ">
            <label for="validationDefaultEmail" className="form-label">
              <strong className="login-text">Enter Your Email</strong>
            </label>
            <input
              type="email"
              className="form-control loginEmailInput"
              id="validationDefaultEmail"
              placeholder="Your Email"
              required
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.email && touched.email ? (
              <p className="form-error">{errors.email}</p>
            ) : null}
          </div>




          <button className="login-button mt-4" type="submit">
            Submit
          </button>
          {/* <div className='d-flex justify-content-center'>
            <Link to="/">
              <button className="goback-button btn btn-primary mt-4" type="submit" >
                Go Back
              </button>
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;